import { UniqueHtmlElement } from './unique-html-element';

export class ProgressBarHandler extends UniqueHtmlElement<HTMLDivElement> {
  /**
   * @type {number}
   */
  maxValue;

  /**
   * @type {number}
   */
  value = 0;

  /**
   *
   * @param {string} selector
   * @param {number} maxValue
   */
  constructor(selector: string, maxValue?: number) {
    super(selector);

    this.maxValue = maxValue;
  }

  /**
   *
   * @param {number} value
   */
  update(value) {
    this.value = value;

    return new Promise<void>(resolve =>
      requestAnimationFrame(() => {
        /**
         * @type {HTMLDivElement}
         */
        const progressBar =
          this.element?.querySelector<HTMLDivElement>('.progress-bar');
        const newWidth = Math.round((value / this.maxValue) * 100);

        if (progressBar !== null && progressBar !== undefined) {
          progressBar.style.width = `${newWidth}%`;
          progressBar.textContent = `${newWidth}%`;
        }

        resolve();
      }),
    );
  }

  increment() {
    return this.update((this.value += 1));
  }

  /**
   *
   * @param {number} maxValue
   */
  setMaxValue(maxValue) {
    this.value = Math.floor(maxValue * 0.05);
    this.maxValue = maxValue + Math.floor(maxValue * 0.05);
  }

  /**
   *
   * @param {string} text
   */
  setInfo(text) {
    const infoText = this.element?.querySelector('p');

    if (infoText !== null && infoText !== undefined) {
      infoText.textContent = text;
    }
  }
}
